import { render, staticRenderFns } from "./System-function.vue?vue&type=template&id=c95f309a&scoped=true&"
import script from "./System-function.vue?vue&type=script&lang=js&"
export * from "./System-function.vue?vue&type=script&lang=js&"
import style0 from "./System-function.vue?vue&type=style&index=0&id=c95f309a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95f309a",
  null
  
)

export default component.exports